import React from 'react'
import { Link } from 'react-router-dom'

const AboutUs = () => {
    return (
        <>

            <main className="-gray-50">

                <section className="border-b bg-white">
                    <div className="mx-auto max-w-6xl px-4 py-10">
                        <h1 className="text-3xl font-bold text-gray-900">About Us</h1>
                        <p className="mt-2 max-w-2xl text-gray-600">
                            Trusted Wrench – Built on Integrity. Local mechanic with 10+ years of experience. Honest service, quality repairs, and dependable results every time.
                        </p>
                    </div>
                </section>


                <section className="mx-auto max-w-6xl px-4 py-12">
                    <div className="space-y-10">

                        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
                            <h2 className="text-xl font-semibold text-gray-900">Our Shop</h2>
                            <p className="mt-3 text-justify leading-7 text-gray-600">
                                We are a full-service automotive repair shop dedicated to keeping your
                                vehicle safe, reliable, and running at its best. With a strong focus on 
                                quality workmanship and honest service, we take pride in delivering repairs 
                                and maintenance you can trust.
                            </p>
                            <p className="mt-3 leading-7 text-justify text-gray-600">
                                Our shop is built on hands-on experience, attention to detail, and a genuine 
                                passion for automotive care. From routine maintenance to complex diagnostics
                                 and repairs, every vehicle is treated with the same level of care and precision. 
                                 We believe in clear communication, transparent pricing, and explaining your options
                                  so you can make informed decisions about your vehicle.
                            </p>
                            <p className="mt-3 text-justify leading-7 text-gray-600">
                                Using modern tools, proven techniques, and industry-standard practices, we service a 
                                wide range of makes and models. Our goal is simple: minimize downtime, extend the life 
                                of your vehicle, and get you back on the road with confidence.
                            </p>

                            <p className="mt-3 text-justify leading-7 text-gray-600">
                                At the heart of everything we do is a commitment to reliability, safety, and long-term
                                customer relationships. When you bring your vehicle to us, you’re not just getting a 
                                repair—you’re getting service you can depend on.
                            </p>
                        </div>


                        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
                            <h2 className="text-xl font-semibold text-gray-900">Meet Our Specialist</h2>

                            <div className="mt-6 flex flex-col gap-6 md:flex-row md:items-center">

                                <div className="flex-shrink-0">
                                    <div className="h-28 w-28 overflow-hidden rounded-full border border-gray-200 bg-gray-100 shadow-sm md:h-32 md:w-32">
                                        
                                    </div>
                                </div>


                                <div className="flex-1">
                                    <div className="flex flex-wrap items-center gap-2">
                                        <h2 className="text-lg font-semibold text-gray-900">
                                            Naseer Khan
                                        </h2>

                                    </div>
                                    <div className="flex flex-wrap items-center gap-2">
                                        <h3 className="text-md font-semibold text-gray-900">
                                            Lead Mechanic and Co-Founder
                                        </h3>

                                    </div>

                                    <p className="mt-3 leading-7 text-gray-600">
                                        Naseer Khan is the founder and lead mechanic of the shop, bringing over a decade of hands-on 
                                        automotive experience to every vehicle he works on. He spent 10 years working with Honda, where 
                                        he developed strong technical expertise, a deep understanding of vehicle systems, and a reputation 
                                        for precision and reliability.
                                        
                                    </p>

                                    {/* And this is developed by noiteration and bistaanj */}
                                    <p className="mt-3 leading-7 text-gray-600">
                                        Through years of working on a wide range of vehicles and complex repairs, Naseer built a strong foundation 
                                        in diagnostics, maintenance, and problem-solving. His experience with manufacturer standards and real-world 
                                        repair challenges shaped his commitment to quality workmanship and honest service.                                        
                                    </p>
                                    <p className="mt-3 leading-7 text-gray-600">
                                        Driven by a passion for automotive care and a desire to provide dependable, customer-focused service, 
                                        he took the next step by opening his own shop. Today, that same dedication, attention to detail, and pride 
                                        in craftsmanship continue to define the way every job is handled—whether it’s routine maintenance or advanced 
                                        mechanical work.
                                        
                                    </p>
                                    


                                </div>
                            </div>
                        </div>


                        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
                            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        Want to book a service?
                                    </h3>
                                    <p className="mt-1 text-gray-600">
                                        Choose a time that works for you and we’ll take care of the rest.
                                    </p>
                                </div>
                                <div

                                    className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-6 py-3 text-sm font-semibold text-white hover:bg-gray-800 transition"
                                >
                                    <Link to="/appointments">
                                        Book Appointment
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

        </>
    )
}

export default AboutUs